// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2KbMU","body":"styles_body__qCcji"};